import PropTypes from "prop-types";
import { TableHead, TableRow, TableCell, TableSortLabel } from "@material-ui/core";

import { useStyles } from "./style";

function DashboardListHeader({
  fields,
  orderBy,
  sortDirection,
  handleSort
}) {

  const createSortHandler = (property) => (event) => {
    handleSort(event, property);
  }

  const classes = useStyles();
  return (
    <TableHead>
      <TableRow>
        {fields.map((field, idx) => (
          <TableCell key={idx} className={classes.cell} sortDirection={orderBy === field.id ? sortDirection : false} padding="none">
            {sortDirection && !!field.id
              ?
              <TableSortLabel
                active={orderBy === field.id}
                direction={orderBy === field.id ? sortDirection : 'asc'}
                onClick={createSortHandler(field.id)}
              >
                {field.label}
                {orderBy === field.id ? (
                  <span className={classes.visuallyHidden}>
                    {orderBy === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
              :
              field.label
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

DashboardListHeader.propTypes = {
  fields: PropTypes.array
};

export default DashboardListHeader;